/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CheckQuestResponse, CheckQuestVars } from '../openapi-types.gen.js';

export type { CheckQuestResponse, CheckQuestVars } from '../openapi-types.gen.js';

export const useCheckQuest = createMutationHook<CheckQuestVars, CheckQuestResponse, unknown>({
  specName: 'useCheckQuest',
  path: '/v1/rewards/quests/{taskId}/check',
  method: 'POST',
  resolveUrl: (vars: CheckQuestVars) => `/v1/rewards/quests/${vars.taskId}/check`,
  
  parseResponse: (raw: unknown): CheckQuestResponse => raw as CheckQuestResponse,
  
  
  
});
